import { CHUNK_ERROR_KEY, CHUNK_ERROR_COOLDOWN_MS } from '../constants';

/**
 * Detect chunk loading errors (common after deployments when old chunks are no longer available).
 * @see https://stackoverflow.com/questions/69047420/webpack-code-splitting-chunkloaderror-loading-chunk-x-failed-but-the-chunk-e
 */
export function isChunkLoadError(error) {
  if (!error) return false;
  const msg = error.message || '';
  const name = error.name || '';
  return (
    name === 'ChunkLoadError' ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('Failed to fetch dynamically imported module')
  );
}

/**
 * Attempt to reload on chunk error, with cooldown to prevent reload loops.
 * @returns {boolean} true if reload was triggered
 */
export function tryReloadOnChunkError(source) {
  const lastReloadAttempt = sessionStorage.getItem(CHUNK_ERROR_KEY);
  const now = Date.now();
  if (!lastReloadAttempt || now - parseInt(lastReloadAttempt, 10) > CHUNK_ERROR_COOLDOWN_MS) {
    sessionStorage.setItem(CHUNK_ERROR_KEY, now.toString());
    console.warn('Chunk loading error detected. Reloading...', source);
    window.location.reload();
    return true;
  }
  return false;
}
